import { render, staticRenderFns } from "./StrategyDetail.vue?vue&type=template&id=4257ae12&scoped=true&"
import script from "./StrategyDetail.vue?vue&type=script&lang=js&"
export * from "./StrategyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4257ae12",
  null
  
)

export default component.exports